import { Stack } from '@mantine/core';
import type { NodeId } from '../../types/graph';
import { useContext } from '@/hooks';
import { OptionField } from '../../molecules/option-field/option-field';
import { formatEvaluationValue, OptionViewModel } from '../../utils';
import { useStore } from '@/store';
import { useCommand } from './use-command';
import { useGraphContext } from '../../context';
import { OptionType } from '@morph-mapper/types';

export type NodeOptionsFormProps = {
  nodeId: NodeId;
  models: OptionViewModel[];
  onOpenGraph: (key: string, graphId?: string) => void;
};

export const NodeOptionsForm = ({
  nodeId,
  models,
  onOpenGraph,
}: NodeOptionsFormProps) => {
  const graphId = useGraphContext(({ graph: g }) => g.getId());
  const [ref] = useStore(({ graphs: g }) => [g.getRef(graphId)]);
  const { findVariables } = useContext(ref.fieldId);
  const { handleUpdate, handleTypeChange } = useCommand(nodeId);

  const getDisplayValue = (model: OptionViewModel) => {
    if (model.type !== OptionType.Graph) return model.value;
    return formatEvaluationValue(model.value);
  };

  const variables = findVariables();

  return (
    <Stack spacing="xl" pt="md" px="md">
      {models
        .filter((m) => m.visible)
        .map((m) => {
          const { key, config, type } = m;
          const graphId = type === OptionType.Graph ? m.graphId : undefined;

          return (
            <OptionField
              key={`${nodeId}:${key}`}
              config={config}
              type={type}
              value={getDisplayValue(m)}
              variables={variables}
              onChange={(value) => handleUpdate(key, value)}
              onTypeChange={(type) => handleTypeChange(key, type)}
              onOpenGraph={() => onOpenGraph(key, graphId)}
            />
          );
        })}
    </Stack>
  );
};
